import { useState,useEffect } from 'react';
import axios from 'axios';
import style from './dating.module.css'
import nopic from '../../img/no_photo_neutral.svg'
import camera from '../../img/camera.png'
import back_ph from '../../img/back_ph.svg'
import next_ph from '../../img/next_ph.svg'
import back from '../../img/back.svg'
import close from '../../img/close.svg'
import like from '../../img/like.png'
import gift from '../../img/gift.png'
import bottom_open from '../../img/bottom.svg'
import { useAuthLocalStorage } from '../../modules/useLocalStore';

function Datings({myProfile , setMyProfile, ThisIsLoad,socketRef}){

    
    const [mobileOpen,SetMobileOpen] = useState(false);
    const [profile,SetProfileDate] = useState({});
    const { getToken, removeToken } = useAuthLocalStorage();
    
    const token = getToken();
    const toggleCard = () => {
        SetMobileOpen(prevState => {
            return !prevState ;
        });
    };
    function bufferToBase64(buffer) {
        let binary = '';
        buffer.forEach(byte => {
            binary += String.fromCharCode(byte);
        });
        return window.btoa(binary);
      }
      const exitPopup = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: null
            }
        }));
    }
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
useEffect(() => {
    const fetchData = async () => {
        try {
            const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getDating`;
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            const response = await axios.post(url, {}, config);
            
            if (!response.data.error) {
                const prof = response.data;
                const text = prof.disc ?? '';
                const hobby = prof.hobby !== null ? prof.hobby.split(',') : [];
                const city = prof.fake > 0 ? myProfile.city : prof.city;
                SetProfileDate(prevState => ({
                    ...prevState,
                    id: prof.id,
                    photo: prof.photo,
                    name: prof.name,
                    day: prof.day,
                    month: prof.month,
                    year: prof.year,
                    city: city,
                    target: prof.target,
                    text: text,
                    hobby: hobby,
                    activeph: 0
                }));

                

               
            }
        } catch (error) {
            console.error('Ошибка при получении данных: ', error);
        }
    };

   fetchData();
}, [myProfile.info.profileactive, ThisIsLoad.current]);

    const getAge = (day, month, year) => {
        const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

        const birthDate = new Date(`${months.indexOf(month) + 1}/${day}/${year}`);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
    
            const absYears = Math.abs(age) % 100; // Берем абсолютное значение и остаток от деления на 100
            const lastDigit = absYears % 10; // Берем остаток от деления на 10
        
            if (absYears > 10 && absYears < 20) {
                return `${age} лет`;
            }
        
            if (lastDigit === 1) {
                return `${age} год`;
            }
        
            if (lastDigit >= 2 && lastDigit <= 4) {
                return `${age} года`;
            }
        
            return `${age} лет`;
    };
    const NextPh = () => {
        const nextIndex = (profile.activeph + 1) % profile.photo.length;
        SetProfileDate(prevState => ({
            ...prevState,
            activeph: nextIndex
        }));
    };

    const BackPh = () => {
        const prevIndex = (profile.activeph - 1 + profile.photo.length) % profile.photo.length;
        SetProfileDate(prevState => ({
            ...prevState,
            activeph: prevIndex
        }));
    };
    const SendMessage = (id) => {
        if(myProfile.vip <= 5) return PopupOpen(5);
        setMyProfile(prevState => ({
            ...prevState,
            sendselect: id
        }));
        PopupOpen(11);
    };
 
    const BackProfile = async () => {
    
    const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/backDating`;
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        try {
                const response = await axios.post(url, {}, config);

                if (response.data.next && socketRef.current) {
                    setMyProfile(prevState => ({
                        ...prevState,
                    info: {
                        ...prevState.info,
                        profileactive: response.data.id_next
                    }
                }));

            }
        } catch (error) {
            console.log(error);
        }
};
    const SendPresent = (id) => {
        setMyProfile(prevState => ({
            ...prevState,
            sendselect: id
        }));
        PopupOpen(9);
    };
    
   
    const NextProfile = async () => {
        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/nextDating`;
            const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        try {
            const response = await axios.post(url, {}, config);

            if (response.data.next) {
                setMyProfile((prevState) => ({
                    ...prevState,
                    info: {
                        ...prevState.info,
                        profileactive: response.data.id_next
                    }
                }));

               
            }
        } catch (error) {
            console.log(error);
        }
    };
    
    const LikeProfile = async () => {
        if (myProfile.limitmessage <= 0) {
            PopupOpen(23);
            return false;
        }
        if(myProfile.limitmessage === 5)
        {
            PopupOpen(24);
        }
         setMyProfile(prevState => ({
            ...prevState,
            limitmessage: prevState.limitmessage-1 
        }));

        const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/likeDating`;
        const config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        try {
            const response = await axios.post(url, {}, config);

            if (response.data.next) {
                setMyProfile(prevState => ({
                    ...prevState,
                    info: {
                        ...prevState.info,
                        profileactive: response.data.id_next
                    }
                }));
                
            } else {
                PopupOpen(23);
                setMyProfile(prevState => ({
                    ...prevState,
                    limitmessage: 0
                }));
            }
        } catch (error) {
            console.log(error);
        }
    };
    return(
        (profile.id ? 
        <div className={style.flexblock}>
            <div className={style.leftblock}>
                <h1>Выбери подходящую анкету и начни знакомство</h1>
            </div>

            <div className={style.rightblock}>
                <div className={style.card}>
                    <div className={style.cardleft} style={{ backgroundImage: `url(${profile.photo[profile.activeph] ? `https://winxy.ru/static_img.php?id=${profile.photo[profile.activeph].id}` : nopic})`}}>
                        <div className={style.topcard}>
                            <div className={style.countph}>
                                 <img src={camera} alt=''/>
                                 <p>{profile && profile.photo && profile.photo.length > 0 ? profile.activeph+1+'/'+profile.photo.length : '1/1' }</p>
                            </div>
                        </div>
                        <div className={style.centercard}>
                            <div className={style.backph} onClick={BackPh}>
                                <img src={back_ph} alt=''/>
                            </div>
                            <div className={style.nextph} onClick={NextPh}>
                                <img src={next_ph} alt=''/>
                            </div>
                        </div>
                        <div className={style.bottomcard}>
                            
                            <div className={style.btnmax} onClick={NextProfile}>
                                <img src={close} alt=''/>
                            </div>
                            <div className={style.btnmax} onClick={LikeProfile}>
                                <img src={like} alt=''/>
                            </div>
                            <div className={style.btnmin} onClick={ () => SendPresent(profile.id)}>
                                <img src={gift} alt=''/>
                            </div>
                        </div>
                    </div>
                    <div className={style.rightcard + ' ' + (mobileOpen ? style.opened : null)}>
                        <div className={style.flexopenmob}>
                            <h3>{profile.name} {getAge(profile.day, profile.month, profile.year)}</h3>
                            <img src={bottom_open} onClick={toggleCard} alt=''/>
                        </div>
                        <div className={style.hidemobile}>
                            <div className={style.scroll}>
                                <div className={style.flexhobby}>
                                    {profile.hobby ?
                                    profile.hobby.map((hb,index) =>
                                        <div key={index} className={style.hobby}>
                                            {hb}
                                        </div>

                                    ):null}
                                    
                                </div>
                            </div>
                            <h4>Город:</h4>
                            <p>{profile.city}</p>
                            <h4>Цель знакомства:</h4>
                            <p>{profile.target}</p>
                            <h4>О себе:</h4>
                            <p>{profile.text}</p>
                            <button className={style.btnsend} onClick={ () => SendMessage(profile.id)}>Написать</button>
                        </div>
                    </div>
                    <div className={style.backend}></div>
                    <div className={style.backendtwo}></div>
                    <div className={style.backendthree}></div>
                </div>
                
            </div>
        </div>
        :
        null)
     );
}

export default Datings;